import { compose, createStore, applyMiddleware, combineReducers } from 'redux';
import thunkMiddleware from 'redux-thunk'; // use for asynchronous actions
import loggerMiddleware from 'lib/middlewares/loggerMiddleware'; // logging... disable for production
import reducers from './reducers';
import { initialStates } from './reducers';

////////////////// EDIT //////////////////

export default props => {
  // This is how we get initial props Rails into redux.
  //const { name } = props;
  const { submit_route, client_ip, stripe_publishable_key, eb_env } = props;
  const { $$initialState } = initialStates;

  Stripe.setPublishableKey(stripe_publishable_key);

  // Redux expects to initialize the store using an Object, not an Immutable.Map
  var state = $$initialState.merge({
    submit_route,
    eb_env,
  });
  state = state.updateIn(
    ['submit_params', 'tos_acceptance', 'ip'],
    val => client_ip
  );

  const initialState = {
    $$appStore: state,
  };

  ////////////////// PERMANENT //////////////////
  const reducer = combineReducers(reducers);
  const composedStore = compose(
    applyMiddleware(thunkMiddleware, loggerMiddleware)
  );
  const storeCreator = composedStore(createStore);
  const store = storeCreator(reducer, initialState);

  return store;
};
